var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15234 17.0977L17.4023 8.84766L16.1133 7.51562L9.15234 14.4766L5.88672 11.2109L4.59766 12.5L9.15234 17.0977ZM4.51172 6.05469C6.31641 4.25 8.47917 3.34766 11 3.34766C13.5208 3.34766 15.6693 4.25 17.4453 6.05469C19.25 7.83073 20.1523 9.97917 20.1523 12.5C20.1523 15.0208 19.25 17.1836 17.4453 18.9883C15.6693 20.7643 13.5208 21.6523 11 21.6523C8.47917 21.6523 6.31641 20.7643 4.51172 18.9883C2.73568 17.1836 1.84766 15.0208 1.84766 12.5C1.84766 9.97917 2.73568 7.83073 4.51172 6.05469Z",
    fill: "#007C6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check_circle.2fb1ad1af423b9357405f71cfd734acc.svg";
export { ForwardRef as ReactComponent };